import { activateExperiment } from './';

const ACTIVE_EXPERIMENT_KEYS = [];

export const activateExperiments = () => {
  ACTIVE_EXPERIMENT_KEYS.forEach(activateExperiment);
};
